import React, { useState, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    InputLabel,
    Checkbox,
    ListItemText,
    ListItemButton,
    OutlinedInput,
    Chip,
    Collapse,
    ListItem,
    Button
} from '@mui/material';

import { grey } from "@mui/material/colors";

import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../common/CommonRestricted';
import { CommonIcons, icons } from "../../common/CommonIcons";

import {
    initialValues,
    initialScopeValues,
    initialTargetValues,
    initialPermissionValues,
    validationSchema
} from "../../../schema/user_roles/userRolePermissionSchema";

import { useUserRoles, roleTypes, targetTypes } from "../../../hooks/api/useUserRoles";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes, permissionConfigs, functionActionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from "../../../hooks/useTranslations";

import { capitalizeString } from "../../../utils/formatString";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function UpdatePermissions({
    roleId,
    routeType,
    permissionRouteType
}) {
    const { t } = useTranslations({ ns: ["common", "@role"] })

    const id = roleId;

    const { promptMessage } = useSystemPrompt();
    const { get, changePermission } = useUserRoles({ roleType: roleTypes.role, targetType: targetTypes.role });
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.userRole.id, scopeTypes.userRole.permission.id)

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const [openCollapseNos, setOpenCollapseNos] = useState([])
    const [savedPermissionKeys, setSavedPermissionKeys] = useState([])

    const [dataPermissions, setDataPermissions] = useState([])

    const fetchRole = async () => {

        try {

            const { data } = await get({ id });

            // console.log('data', data)

            let permissions = data?.role?.permissions ? data?.role?.permissions : []

            // setDataPermissions()

            loadPermissionIntoStates({
                selected: permissions
            })

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const onSubmitChangePermission = async (props) => {

        const { scopeId, scopeValue, targetId, permissionId, status, onSuccess } = props

        try {

            let isCustomScopeId = 0

            // check the scope is custom
            Object.keys(scopeIds).forEach(i => {

                if (scopeIds[i].id === scopeId) {
                    if (scopeIds[i]?.isCustom) {
                        isCustomScopeId = 1
                    }
                }

            })

            // console.log('check', scopeId, isCustomScopeId)

            let data = {
                permissions: [{
                    // scope_type: scopeId,
                    scope_type: scopeValue,
                    scope_name: targetId,
                    permission_type: permissionId,
                    status: status ? 1 : 0,
                    is_custom: isCustomScopeId
                }]
            }

            const response = await changePermission({ id, data });

            promptMessage(true, `${response?.message}`)
            // navigate(getRoute("users/administrators"))

            if (onSuccess) onSuccess()

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    // toggle the permission key status on off
    // const UpdatePermissionKeys = ({ ids }) => {

    //     let saved = savedPermissionKeys

    //     ids.forEach((id, index) => {

    //         // check the id is exists
    //         const checkExist = saved.filter(i => i === id)

    //         // if exist - need remove it
    //         if (checkExist.length > 0) {
    //             saved = saved.filter(i => i !== id)
    //         } else {
    //             // if not exist - append it
    //             saved.push(id)
    //         }

    //     })

    //     // console.log('saved', ids, saved)

    //     return saved

    // }

    const getFunctionTypesArray = (functionType) => {
        return functionTypes[functionType]
    }

    const getPermissionsArray = (scopeType, targetType) => {

        let items = permissionConfigs[scopeType][targetType]

        // console.log('items', items, scopeType, targetType)

        let permissions = []

        Object.keys(items).forEach((i, index) => {

            let ftKey = i;
            let item = items[ftKey]

            // remove irrelevant route type permission
            let enable = `${permissionRouteType}` in item // check if the prop has

            if (enable) {

                // check also the status must true
                if (item[permissionRouteType] === true) {
                    // look for the function definition
                    const fT = getFunctionTypesArray(ftKey)

                    permissions.push({
                        ...fT
                    })
                }

            }

        })

        // console.log('permission', permissionRouteType, scopeType, permissions)

        return {
            [functionActionTypes.pageAccess]: permissions.filter(i => i.type === functionActionTypes.pageAccess),
            [functionActionTypes.callAction]: permissions.filter(i => i.type === functionActionTypes.callAction)
        }

    }

    const getScopeTargetArray = (scopeType) => {
        let data = scopeTypes[scopeType]

        let targetKeys = Object.keys(data).filter((i, index) => {
            return data[i]?.id
        })

        let targetArray = [];
        targetKeys.forEach((i, index) => {

            let targetType = data[i]?.id

            // console.log('data[i]', data[i], i)

            targetArray.push({
                ...data[i],
                targetType,
                scopeType,
                scopeValue: scopeIds[scopeType].value,
                permissions: getPermissionsArray(scopeType, targetType)
            })
        })


        // console.log('targetArray', targetArray, scopeType)

        return targetArray
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: () => {

        }
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    useEffect(() => {

        // fetch the role permissions
        fetchRole()

    }, [])

    const loadPermissionIntoStates = ({ selected }) => {

        let scopeKeys = Object.keys(permissionConfigs)

        let scopes = [];

        // console.log('selected', selected)

        scopeKeys.forEach((i, index) => {

            let a = getScopeTargetArray(i)

            // console.log('a', i, a)

            // state for target
            let target = []

            a.forEach((i2, index2) => {

                let p = i2.permissions[functionActionTypes.pageAccess].concat(i2.permissions[functionActionTypes.callAction])

                // state for permissions
                let permissions = p.map(i3 => {

                    // generate key for permission
                    let key = `${index}_${i}_${i2.id}_${i3.id}`

                    // check the selected key is exists
                    // let status = false; // savedPermissionKeys.includes(key)

                    // console.log('dataPermissions', dataPermissions)

                    // filte
                    const checkStatus = selected.filter((itemP, indexP) => {

                        if (
                            itemP.permission_type === i3.id &&
                            itemP.scope_type === i2.scopeValue &&
                            itemP.scope_name === i2.id
                        ) {
                            return true
                        }

                        return false

                    })

                    // console.log('checkStatus', checkStatus.length, i, i2.id, i3.id)

                    let status = checkStatus.length > 0

                    return {
                        ...initialPermissionValues,
                        key,
                        permissionId: i3.id,
                        permissionName: i3.label,
                        type: i3.type,
                        description: i3?.description,
                        status
                    }
                })

                target.push({
                    ...initialTargetValues,
                    value: i2?.scopeValue,
                    targetId: i2.id,
                    targetName: i2.label,
                    description: i2?.description,
                    permissions
                })

            })

            scopes.push({
                ...initialScopeValues,
                scopeId: i,
                scopeName: scopeTypes[i]?.label,
                description: scopeTypes[i]?.description,
                target
            })

        })

        // console.log('scope', permissionConfigs)

        setFieldValue(`routeType`, permissionRouteType)
        setFieldValue('scopes', scopes)

        // console.log('scopes', scopes)

        // setFieldValue()

    }

    const handleChangePermission = async ({ scopeId, scopeValue, targetId, permissionId, key }) => {

        // let a = UpdatePermissionKeys({ ids: [key] })

        // setSavedPermissionKeys(a)

        let ind1 = '';
        let ind2 = '';
        let ind3 = '';
        let currentStatus = false;

        // look for the index for all
        values.scopes.forEach((i1, index1) => {
            i1.target.forEach((i2, index2) => {
                i2.permissions.forEach((i3, index3) => {

                    if (key === i3.key) {
                        ind1 = index1
                        ind2 = index2
                        ind3 = index3
                        currentStatus = i3.status
                    }

                })
            })
        })

        // console.log(`scopes.${ind1}.target.${ind2}.permissions.${ind3}.status`, currentStatus)

        // update the backend
        await onSubmitChangePermission({
            scopeId,
            scopeValue,
            targetId,
            permissionId,
            status: !currentStatus,
            onSuccess: () => {
                setFieldValue(`scopes.${ind1}.target.${ind2}.permissions.${ind3}.status`, !currentStatus)
            }
        })

    }

    const RenderSelect = ({ permissions, scopeId, targetId, scopeValue }) => {

        // console.log('permissions', permissions)

        return (
            <div style={{ width: '100%' }}>
                <Box
                    sx={{
                        // flexWrap: 1,
                        // display: 'flex',
                        // flex: 1,
                        // flexDirection: 'row',
                        // backgroundColor: 'yellow',
                        // justifyContent: 'flex-start',
                        // alignItems: 'flex-start'
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(5, 1fr)',
                    }}
                >
                    {
                        permissions.map((i, index) => {

                            let permissionKey = i?.key
                            let permissionId = i?.permissionId
                            let name = i?.permissionName ? i.permissionName : '-'
                            let description = i?.description ? i.description : "-"
                            let status = i?.status

                            // console.log('i', i)

                            let selected = status; // savedPermissionKeys.includes(permissionKey)

                            return (
                                <Box key={permissionKey}>
                                    {/* {JSON.stringify(selected)} */}
                                    <Button
                                        fullWidth
                                        variant={selected ? 'contained' : 'outlined'}
                                        color={
                                            "primary"
                                            // selected ? "primary.main" : "primary.default"
                                        }
                                        // sx={{
                                        //     // width: 1 / 5,
                                        //     backgroundColor: selected ? 'red' : 'grey',
                                        // }}
                                        sx={{
                                            py: 0,
                                            px: 1
                                        }}
                                        onClick={() => {
                                            // setSavedPermissionKeys([...savedPermissionKeys, permissionKey])
                                            handleChangePermission({ scopeId, scopeValue, targetId, permissionId, key: permissionKey })
                                        }}
                                    >
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    sx={{
                                                        color: "primary",
                                                        fontSize: 14,
                                                        fontWeight: '800',
                                                        textAlign: "left",
                                                        lineHeight: 1.1
                                                    }}
                                                >
                                                    {name}
                                                </Typography>
                                            }
                                            secondary={
                                                <Typography
                                                    sx={{
                                                        color: "secondary",
                                                        fontSize: 10,
                                                        textAlign: "left",
                                                        // mt: -0.5
                                                    }}
                                                >
                                                    {description}
                                                </Typography>
                                            }
                                        />
                                    </Button>
                                    {/* <ListItem
                                        key={permissionKey}
                                        value={permissionKey}
                                        
                                    >
                                        
                                    </ListItem> */}
                                </Box>
                            )
                        })
                    }
                </Box>
            </div>
        )

    }

    const RenderPermissionRowItem = ({ index, scope, target, permissions }) => {

        let targetId = target?.targetId
        let scopeId = scope?.scopeId

        let name = target?.targetName ? target.targetName : '-'
        let description = target?.description ? target.description : "-"

        let scopeValue = scope?.target[0].value

        // console.log('permissions', permissions)

        if (permissions.length <= 0) return <></>

        // console.log('target', scopeId, target, permissions)

        return (
            <Grid item key={index} xs={12} sx={{ px: 1, py: 1 }}>

                <Grid container spacing={0} sx={{ mb: 1 }}>
                    <Grid item xs={9} display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"}>

                        <Typography
                            sx={{
                                color: grey[700],
                                fontSize: 15,
                                fontWeight: '800'
                            }}
                        >
                            {capitalizeString({ val: name })}
                            {/* {JSON.stringify(scopeValue)} */}
                            {/* {JSON.stringify(targetId)} */}
                        </Typography>

                        <Typography
                            sx={{
                                color: grey[600],
                                fontSize: 13,
                                ml: 1,
                                fontStyle: 'italic'
                            }}
                        >
                            {capitalizeString({ val: description })}
                        </Typography>

                        {/* <ListItemText
                            primary={
                                <Typography
                                    sx={{
                                        color: grey[700],
                                        fontSize: 15,
                                        fontWeight: '800'
                                    }}
                                >
                                    {capitalizeString({ val: name })}
                                </Typography>
                            }
                            secondary={
                                <Typography
                                    sx={{
                                        color: grey[600],
                                        fontSize: 12,
                                    }}
                                >
                                    {capitalizeString({ val: description })}
                                </Typography>
                            }
                        /> */}
                    </Grid>
                    {/* <Grid item xs={3}>

                        <Box
                            textAlign={"right"}
                        >
                            <FormControlLabel
                                control={<Checkbox defaultChecked />}
                                sx={{
                                    mr: 0,
                                    pr: 0
                                }}
                                label={
                                    <Typography
                                        sx={{
                                            fontSize: 13,
                                            color: grey[800],
                                            pr: 0,
                                            mr: 0
                                        }}
                                    >
                                        Select All
                                    </Typography>
                                }
                            />
                        </Box>

                    </Grid> */}
                    <Grid item xs={12}>
                        <RenderSelect
                            scopeId={scopeId}
                            targetId={targetId}
                            scopeValue={scopeValue}
                            permissions={permissions}
                        />
                        {/* {
                            RenderSelect({
                                scopeId,
                                targetId,
                                permissions
                            })
                        } */}
                    </Grid>
                </Grid>

                <Divider sx={{ pt: 1 }}><></></Divider>

            </Grid>
        )
    }

    const RenderPermissionRowCollapse = ({
        scope, target
    }) => {

        // console.log('target', target)

        return (
            <Box
                sx={{
                    px: 1,
                    py: 1
                }}
            >
                <Grid container>
                    {
                        target.map((i, index) => {

                            let id = `${index}_${scope?.scopeId}_${i?.targetId}`

                            return (
                                <RenderPermissionRowItem
                                    key={`${id}`}
                                    scope={scope}
                                    target={i}
                                    permissions={i.permissions}
                                />
                            )

                            // return RenderPermissionRowItem({
                            //     key: id,
                            //     index: id,
                            //     scope,
                            //     target: i,
                            //     permissions: i.permissions
                            // })
                        })
                    }
                </Grid>
            </Box>
        )
    }

    const actionClickCollapse = ({ index }) => {

        let saved = openCollapseNos

        // check index selected 
        const selected = saved.filter(i => i === index)

        // console.log('selected, selected', selected)

        // if existed
        if (selected.length > 0) {
            setOpenCollapseNos(saved.filter(i => i !== index))
        } else {
            setOpenCollapseNos(saved.concat(index))
        }


    }

    const RenderPermissionRow = ({ index, scope }) => {

        let currentIndex = openCollapseNos

        // check scope target if empty just skip to show
        let haveChildren = false
        let totalPermissionCount = 0;
        let totalAllowPermission = 0;

        scope?.target.forEach(e1 => {
            let permissions = e1.permissions
            if (permissions.length > 0) haveChildren = true

            totalPermissionCount += permissions.length

            const allowPermissions = permissions.filter(i => i.status === true)

            totalAllowPermission += allowPermissions.length

        })

        // console.log('scope?.target', scope?.target)

        if (haveChildren === false) return <></>


        return (
            <>
                <ListItem
                    disableGutters
                    disablePadding
                    divider
                >
                    <ListItemButton
                        sx={{
                            width: '100%',
                            px: 2,
                            // bgcolor: grey[100]
                        }}
                        onClick={() => {
                            actionClickCollapse({ index: parseInt(index, 10) })
                        }}
                        disableGutters
                        selected={currentIndex.includes(index)}
                    >
                        <ListItemText
                            primary={
                                <Typography
                                    sx={{
                                        fontWeight: '800'
                                    }}
                                >
                                    {capitalizeString({ val: scopeIds[scope?.scopeId]?.label ? scopeIds[scope?.scopeId]?.label : "-" })}

                                </Typography>
                            }
                        />
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"flex-end"}
                            alignItems={"center"}
                        >
                            <Typography
                                sx={{
                                    fontWeight: '400',
                                    color: grey[500],
                                    mr: 1
                                }}
                            >
                                {
                                    `${totalAllowPermission} / ${totalPermissionCount}`
                                }
                            </Typography>
                            {
                                currentIndex.includes(index) ? <CommonIcons name={icons.chevronUp} /> : <CommonIcons name={icons.chevronDown} />
                            }
                        </Box>
                    </ListItemButton>


                </ListItem>
                <Collapse in={currentIndex.includes(index)} timeout="auto" unmountOnExit>

                    <RenderPermissionRowCollapse
                        scope={scope}
                        target={scope?.target}
                    />
                    {/* {
                        RenderPermissionRowCollapse({
                            scope,
                            target: scope?.target
                        })
                    } */}

                </Collapse>
            </>
        )
    }

    const RenderPermissions = () => {

        if (!values) return <></>

        return (
            <>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                    <CommonSectionHeader
                        title={t('permissions')}
                        subTitle={t('selectWhichActionsThePeopleWithThisRoleCanPerform')}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                    {/* {JSON.stringify(values.scopes)} */}
                    {
                        values.scopes.map((i, index) => {
                            // console.log('i', scopeTypes[i])
                            return (
                                <RenderPermissionRow
                                    key={index}
                                    index={index}
                                    scope={i}
                                />
                            )

                            // return RenderPermissionRow({
                            //     key: index,
                            //     scope: i
                            // })
                        })
                    }

                </Grid>

            </>
        )
    }

    const RenderForm = () => {

        return (

            <form onSubmit={formik.handleSubmit}>
                {/* <Typography sx={{ fontSize: 11 }}>
                    {JSON.stringify(values)}

                </Typography> */}
                <StyledCard>
                    <Grid container spacing={1}>

                        {
                            RenderPermissions()
                        }

                    </Grid>
                </StyledCard>
                {/* <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            Save Changes
                        </LoadingButton>
                    </Grid>
                </Grid> */}
            </form>

        )
    }

    return (
        <Box>
            {/* {JSON.stringify(savedPermissionKeys)} */}
            {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}